import React from 'react'
import PropTypes from 'prop-types'

/**
 * 
 * A row in the verification results table
 * that gives one warning or error.
 */
function VerifyResultsRow({ category, message, rows }) {
  return (
    <tr>
      <td>{category}</td>
      <td>{message}</td>
      <td>{rows}</td>
    </tr>
  )
}

const { string, array } = PropTypes

VerifyResultsRow.propTypes = {
  category: string.isRequired,
  message: string.isRequired,
  rows: string.isRequired,
}

export default VerifyResultsRow


// WEBPACK FOOTER //
// ./src/components/Assessment/UploadCSVComponents/VerifyResultsRow.js